(function (angular) {
	'use strict';

	angular
		.module('modalModule')
		.directive('modalTrigger', [
			'$rootScope',
			'$templateRequest',
			'STATIC_BASE_PATH',
			'mixpanelFactory',
			ModalTriggerFunction
		]);

	function ModalTriggerFunction(
		$rootScope,
		$templateRequest,
		STATIC_BASE_PATH,
		mixpanelFactory) {
		
		return {
			restrict: 'A',
			scope: {
				disclaimerName: '@?',
				modalParams: '<',
				modalTitle: '<?'
			},
			link: function ($scope, $elem, $attrs) {
				$elem.bind('click', function(e) {
					$rootScope.ModalFactory.openDisclaimer($scope.disclaimerName, {
						inputs: {
							title: $scope.modalTitle,
							params: $scope.modalParams
						}
					});
				});
			}
		};
	}
})(window.angular);